import { Typography } from '@rossum/ui/material';
import React, { CSSProperties, MouseEventHandler } from 'react';
import { Link, LinkProps } from 'react-router-dom';

export type Chunks = React.ReactNode;

export const white = (chunks: Chunks[]) => (
  <Typography variant="inherit" component="span" color="text.primary">
    {chunks}
  </Typography>
);

export const gray = (chunks: Chunks[]) => (
  <Typography variant="inherit" component="span" color="text.secondary">
    {chunks}
  </Typography>
);

export const boldText = (chunks: Chunks[]) => (
  <Typography variant="inherit" component="span" sx={{ fontWeight: 'bold' }}>
    {chunks}
  </Typography>
);

export const italicText = (chunks: Chunks[]) => (
  <Typography variant="inherit" component="span" sx={{ fontStyle: 'italic' }}>
    {chunks}
  </Typography>
);

export const linebreak = <br />;

export const nbsp = '\u00a0';

export const button =
  (
    onClick: MouseEventHandler<HTMLButtonElement>,
    style?: CSSProperties,
    dataCy?: string
  ) =>
  (chunks: Chunks[]) => (
    <button
      type="button"
      onClick={onClick}
      style={{
        background: 'none',
        padding: 0,
        border: 'none',
        ...style,
      }}
      data-cy={dataCy}
    >
      <Typography
        variant="inherit"
        component="span"
        sx={{
          textDecoration: 'underline',
          '&:hover': { textDecoration: 'none' },
        }}
      >
        {chunks}
      </Typography>
    </button>
  );

export const link =
  (href: string, style?: CSSProperties, dataCy?: string) =>
  (chunks: Chunks[]) => (
    <Typography
      component="a"
      variant="inherit"
      color="inherit"
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      sx={{
        textDecoration: 'underline',
        '&:hover': { color: 'inherit', textDecoration: 'none' },
      }}
      style={style}
      data-cy={dataCy}
    >
      {chunks}
    </Typography>
  );

export const routerLink =
  ({
    route,
    backLink,
    attributes = {},
  }: {
    route: string;
    backLink?: string;
    attributes?: Omit<LinkProps, 'to'>;
  }) =>
  (chunks: Chunks[]) => (
    <Link
      {...attributes}
      to={
        backLink
          ? {
              pathname: route,
              state: { backLink },
            }
          : route
      }
    >
      {chunks}
    </Link>
  );
